import { useEffect, useState } from "react";
import ContactForm from './ContactForm';
import Nav from './sections/Nav';
import Hero from './sections/Hero';
import GroundReality from './sections/GroundReality';
import HowItWorks from './sections/HowItWorks';
import Contact from './sections/Contact';
import Footer from './sections/Footer';
import { useSEO } from './useSEO';
import './layout.css';

const LandingPage = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [contactFormMode, setContactFormMode] = useState('contact');

  useSEO({
    title: 'Nthra Labs | Digital Material Passport for Manufacturing Supply Chains',
    description: 'Digital Material Passport turns buyer requirements, regulatory standards, supplier certificates, and production data into deterministic, machine-verifiable proof of conformance for every shipment.',
    path: '/',
  });

  const openContactForm = (mode) => {
    setContactFormMode(mode);
    setIsContactFormOpen(true);
  };

  useEffect(() => {
    if (!window.location.hash) return;
    const el = document.getElementById(window.location.hash.slice(1));
    if (el) el.scrollIntoView();
  }, []);

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", background:"#ffffff", color:"#1a1a1a", minHeight:"100vh" }}>
      <Nav onOpenContact={openContactForm} />
      <Hero onOpenContact={openContactForm} />
      <GroundReality />
      <HowItWorks />
      <Contact onOpenContact={openContactForm} />

      <Footer />

      <ContactForm
        isOpen={isContactFormOpen}
        onClose={() => setIsContactFormOpen(false)}
        mode={contactFormMode}
      />
    </div>
  );
};

export default LandingPage;
